<template>
    <div>
        <div class="page-header line-pc">
            <img class="icon" src="../../assets/image/company-icon.png" alt="" />
            <div class="menu-box">
                <div class="item-menu" :class="{ 'item-menu-active': activeMenu == item.path }" v-for="item in menuList" :key="item.path"
                    @click="handleActived(item.path)">
                    {{ item.name }}
                </div>
            </div>
            <div class="school-name-box">
                <el-dropdown @command="handleClickLogin">
                    <div class="school-name">
                        <div class="school-icon" v-if="userData.realName">{{ userData.realName.slice(0, 1) }}</div>
                        <span>{{ userData.realName }}</span>
                    </div>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
import { logout } from "@/api/user/index.js";
export default {
    computed: {
        ...mapState(["userData"]),
        menuList() {
            return this.$store.getters.getMenuList;
        },
        // 当前高亮的一级菜单：精确匹配，或子路由前缀匹配（如/setting/userManage高亮"系统设置"）
        activeMenu() {
            const path = this.$route.path;
            if (this.menuList.some(x => x.path === path)) {
                return path;
            }
            const parent = this.menuList.find(x => x.path && x.path !== '/' && path.startsWith(x.path + '/'));
            return parent ? parent.path : path;
        }
    },
    methods: {
        // 退出登录
        handleClickLogin(command) {
            if (command === 'logout') {
                logout().then(() => {
                    localStorage.removeItem('accessToken');
                    this.$store.commit("setUserData", {});
                    this.$router.replace("/login");
                }).catch((err) => {
                    console.log(err, "err");
                });
            }
        },
        handleActived(path) {
            this.$router.push(path);
        },
    },
};
</script>
<style lang="scss" scoped>
// pc端
@media only screen and (min-width: 768px) {
    .page-header {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        z-index: 99;
        height: $pc-header-height;
        background-color: #0440c3;
        display: flex;
        align-items: center;
        padding: 0 1.9rem;
        .icon {
            width: 14.5rem;
        }
        .menu-box {
            width: 50%;
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-left: auto;
            .item-menu {
                padding: 0 0.4rem;
                cursor: pointer;
            }
            .item-menu-active {
                font-size: 1.14rem;
                padding-bottom: 0.3rem;
                border-bottom: 2px solid #fff;
            }
        }
        .school-name-box {
            width: 16%;
            @include bothCenter;
        }
        .school-name {
            color: #fff;
            font-size: 0.86rem;
            @include bothCenter;
            cursor: pointer;
            .school-icon {
                display: inline-block;
                width: 1.6rem;
                height: 1.6rem;
                line-height: 1.5rem;
                margin-right: 5px;
                border-radius: 50%;
                border: 1px solid #fff;
                text-align: center;
            }
        }
    }
}
</style>
